window.__assetPrefix__ = 'https://d2m28ae74ax9f1.cloudfront.net/frontend-talent-mf';